import Model from 'flarum/common/Model';
export default class RemovedSpecies extends Model {
  gbifId() {
    return Model.attribute('gbifId').call(this);
  }
  scientificName() {
    return Model.attribute('scientificName').call(this);
  }
}
flarum.reg.add('champis-species', 'common/models/RemovedSpecies', RemovedSpecies);